// host_config.jsx
//const hostserver = "http://localhost:5000";
 const hostserver = "https://liveliveentertain.com";

export default hostserver;
